import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import NRHero from "./components/NRHero";
import NRContent from "./components/NRContent";
import NRShopSection from "./components/NRShopSection";
import NRFormula from "./components/NRFormula";
import NRRelated from "./components/NRRelated";
import NRBottomCTA from "./components/NRBottomCTA";

export default function NeutralRugsPage() {
  return (
    <div className="min-h-screen bg-[#FDFAF5]" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <main>
        <NRHero />
        <div className="max-w-screen-xl mx-auto px-8 md:px-16">
          <NRContent />
          <NRShopSection />
          <NRFormula />
        </div>
        <NRRelated />
        <NRBottomCTA />
      </main>
      <Footer />
    </div>
  );
}
